import { render } from "./App.vue?vue&type=template&id=117d64cb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=117d64cb&lang=scss"

import exportComponent from "C:\\Users\\RuZja\\Desktop\\Projects\\ruzja\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__